import { motion } from "framer-motion";

type Props = {
  className?: string;
  withTopBorder?: boolean;
};

const CambriaSponsorBlock = ({ className = "", withTopBorder = true }: Props) => {
  return (
    <motion.div
      className={`flex flex-col items-center gap-5 ${
        withTopBorder ? "pt-10 md:pt-14 border-t border-yacht-charcoal/10" : ""
      } ${className}`}
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <p className="text-yacht-blue text-[11px] md:text-xs font-bold tracking-[0.3em] uppercase">
        ★ Official Hotel Partner ★
      </p>
      <a
        href="https://cambriadetroit.com/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Cambria Hotel Detroit Downtown — Official Hotel Partner of Yacht Rock Detroit"
        className="inline-block transition-opacity hover:opacity-80"
      >
        <img
          src="/cambria-logo.png"
          alt="Cambria Hotel Detroit Downtown"
          className="h-20 md:h-24 w-auto"
          loading="lazy"
        />
      </a>
      <p
        className="text-yacht-charcoal/70 text-sm md:text-base italic text-center"
        style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
      >
        Detroit's Official Festival Hotel
      </p>
    </motion.div>
  );
};

export default CambriaSponsorBlock;
